import React from 'react'
import FieldNames from '../../../../aiim/datasets/FieldNames';
import * as aiimUtil from '../../../../aiim/util/aiimUtil';
import { ModalController } from '../../../../common/components/Modal';
import * as component from '../../../../components/util/component'
import Context from '../../../../context/Context';
import * as transactions from '../../../base/transaction/transactions';
import AssignmentIcon from "calcite-ui-icons-react/RouteToIcon";
import * as multipleAssignmentsUtil from "./multipleAssignmentsUtil";

import { Container } from "../../../styles/Common/selectArea";
import Button from '../../../../common/components/Button';
import Form, {
  Fieldset,
  FormControl
} from "calcite-react/Form";
import Checkbox from "calcite-react/Checkbox";
import { CalciteP } from 'calcite-react/Elements/Elements-styled';
import { hasAreasFields } from '../../../base/sourceUtil';
import { Field } from 'formik';


export default class AssignmentsPromptPeople extends React.Component {
  constructor(props) {
    super(props)
    this.state = component.newState({
      // keepAssignment: false,
      keepAssignment: true,
      unassignAssignments: false,
      names: []
    })
  }

  componentDidMount() {
    const assignments = this.props.assignments
    const currentAssignment = this.props.currentAssignment
    const areas = assignments.areas
    const units = assignments.units
    const names = []
    areas.forEach(area => {
      const areaName = aiimUtil.getAttributeValue(area.attributes, FieldNames.AREA_NAME)
      if (areaName && areaName !== currentAssignment) names.push(areaName)
    })
    units.forEach(unit => {
      const unitName = aiimUtil.getAttributeValue(unit.feature.attributes, FieldNames.NAME)
      if (unitName && unitName !== currentAssignment) names.push(unitName)
    })
    this.setState({
      names: names
    })
  }

  componentWillUnmount() {
    component.componentWillUnmount(this)
  }

  onUnassignCheckChange = (evt) => {
    const checked = !!evt.target.checked
    this.setState({
      unassignAssignments: checked
    })
    if (this.props.onUnassignChanged) {
      this.props.onUnassignChanged(checked)
    }
  }

  onCurrentCheckChange = (evt) => {
    const checked = !!evt.target.checked
    this.setState({
      keepAssignment: checked
    })
    if (this.props.onCurrentChanged) {
      this.props.onCurrentChanged(checked)
    }
  }

  makeText = (person, assignTo) => {
    const i18n = Context.instance.i18n
    const baseString = i18n.spaceplanner.multipleAssignments.modalText
    const personAttributes = person.feature && person.feature.attributes
    const personName = aiimUtil.getAttributeValue(personAttributes, FieldNames.PEOPLE_FULLNAME)
    const assignToAttributes = assignTo.attributes || assignTo.feature.attributes
    const areaName = aiimUtil.getAttributeValue(assignToAttributes, FieldNames.AREA_NAME)
    let assignToName = null
    if (areaName) {
      assignToName = areaName
    } else {
      assignToName = aiimUtil.getAttributeValue(assignToAttributes, FieldNames.NAME)
    }
    if (personName && assignToName) {
      return baseString.replace("{name}", personName).replace("{assignToName}", assignToName)
    } else return null
  }

  renderItemTag(text) {
    // Make button eventually
    return (
      <div className="i-modal-tag">
        {text}
      </div>
    )
  }

  render() {
    const i18n = Context.instance.i18n
    const formStyle = {maxHeight: '2.5rem'}
    //#region 
    // const currentAssignments = null
    // const otherOccupants = null
    // const assignToFeature = this.props.assignToFeature
    // const assignToAttributes = assignToFeature.attributes || (assignToFeature.feature && assignToFeature.feature.attributes)
    // const areaType = aiimUtil.getAttributeValue(assignToAttributes, FieldNames.AREA_TYPE)
    // const useType = aiimUtil.getAttributeValue(assignToAttributes, FieldNames.UNITS_USE_TYPE)
    // let description = 
    //   areaType === "hotdesk" ? i18n.spaceplanner.multipleAssignments.assignTo.hotdesk :
    //   areaType === "hotel" ? i18n.spaceplanner.multipleAssignments.assignTo.hotel :
    //   useType
    // const assignToName = areaType ? 
    //   aiimUtil.getAttributeValue(assignToAttributes, FieldNames.AREA_NAME) :
    //   aiimUtil.getAttributeValue(assignToAttributes, FieldNames.NAME)
    // const assignToTitle = i18n.spaceplanner.multipleAssignments.assignTo.title
    //   .replace("{name}", assignToName)
    //   .replace("{type}", description)
    // const personFeature = this.props.personFeature
    // const personName = aiimUtil.getAttributeValue(personFeature.feature.attributes, FieldNames.PEOPLE_FULLNAME)
    // const personEmail = aiimUtil.getAttributeValue(personFeature.feature.attributes, FieldNames.PEOPLE_EMAIL)
    // const assignmentIconStyle = Context.instance.uiMode.isRtl ? 
    //   {transform: "rotate(270deg)"} : 
    //   {transform: "rotate(90deg)"}
    //#endregion

    const otherChoiceNode = this.state.names.length > 0 ? (
      <Form style={formStyle}>
        <FormControl>
          <Fieldset name="assignmentOption">
            <Checkbox
              checked={this.state.unassignAssignments}
              onChange={this.onUnassignCheckChange}>
              {/* {i18n.spaceplanner.multipleAssignments.unassignAssignments} */}
              {"Unassign from:"}
            </Checkbox>
          </Fieldset>
        </FormControl>
      </Form>
    ) : null

    const style = this.props.dnd ? {marginBottom: '0.75rem'} : {}
    const otherNamesNode = this.state.names.length > 0 ? (
      <div className={"i-assignment-names"} style={style}>
        {/* {this.state.names.join(", ")} */}
        {this.state.names.map(n => this.renderItemTag(n))}
      </div>
    ) : null

    const currentChoiceNode = this.props.currentAssignment && this.props.showKeepCurrentAssignment ? (
      <Form style={formStyle}>
        <FormControl>
          <Fieldset name="assignmentOption">
            <Checkbox
              checked={this.state.keepAssignment}
              onChange={this.onCurrentCheckChange}>
              {/* {i18n.spaceplanner.multipleAssignments.keepAssignment} */}
              {"Unassign from:"}
            </Checkbox>
          </Fieldset>
        </FormControl>
      </Form>
    ) : null

    const currentNamesNode = this.props.currentAssignment && this.props.showKeepCurrentAssignment ? (
      <div className={"i-assignment-names"}>
        {/* {this.props.currentAssignment} */}
        {this.renderItemTag(this.props.currentAssignment)}
      </div>
    ) : null

    const text = this.makeText(this.props.personFeature, this.props.assignToFeature)
    const textNode = text ? (<CalciteP>{text}</CalciteP>) : null

    const showDivider = this.props.currentAssignment &&
     this.props.showKeepCurrentAssignment && 
     !!this.props.hasPeopleAssigned
    const divider = showDivider ? (<span style={{borderBottom: '1px solid #eaeaea', width: '100%'}}></span>) : null

    if (this.props.dnd) {
      return (
        <>
          {currentChoiceNode}
          {currentNamesNode}
          {otherChoiceNode}
          {otherNamesNode}
          {divider}
        </>
      )
    }

    return (
      <div className="i-unassign-assignments">
        {textNode}
        {currentChoiceNode}
        {currentNamesNode}
        {otherChoiceNode}
        {otherNamesNode}
      </div>
    )
    //#region 
    // return (
    //   <Container>
    //     <div className="i-multiple-assignments">
    //       <div className="i-people-features">
    //         <h4 className="i-people-names">{personName}</h4>
    //         <div className="i-people-actions">
    //           <AssignmentIcon style={assignmentIconStyle} />
    //           <h5>{assignToTitle}</h5>
    //           <Button className={"i-apply-button"}>Apply</Button>
    //         </div>
    //       </div>
    //       <div className="i-current-assignments">
    //         <div className="i-keep-remove"></div>
    //         <ul className="i-current-assignments-list">
    //           {currentAssignments}
    //         </ul>
    //       </div>
    //       <div className="i-other-occupants">
    //         <div className="i-keep-remove"></div>
    //         <ul className="i-other-occupants-list">
    //           {otherOccupants}
    //         </ul>
    //       </div>
    //     </div>
    //   </Container>
    // )
    //#endregion
  }

  static showModal(props) {
    let content, controller, okButton
    const i18n = Context.instance.i18n
    const personFeature = props.personFeature
    const assignToFeature = props.assignTo
    const assignments = props.assignments
    const currentAssignment = props.currentAssignment
    const showKeepCurrentAssignment = !!props.showKeepCurrentAssignment
    // console.log(personFeature)
    // transactions.addPerson(personFeature, assignToFeature, null)
    // transactions.addPerson(personFeature, null, assignToFeature)
    // transactions.deletePerson(personFeature)

    let unassignAssignments = false
    const onUnassignChanged = (checked) => {
      unassignAssignments = !!checked
    }

    let keepCurrentAssignment = showKeepCurrentAssignment ? false : "not-shown"
    const onCurrentChanged = (checked) => {
      keepCurrentAssignment = !!!checked
    }

    const onOK = () => {
      if (props && props.onOK) {
        props.onOK(unassignAssignments, keepCurrentAssignment)
      }
    }

    let selectProps = {
      personFeature: personFeature,
      assignToFeature: assignToFeature,
      assignments: assignments,
      currentAssignment: currentAssignment,
      showKeepCurrentAssignment: showKeepCurrentAssignment,
      onUnassignChanged: onUnassignChanged,
      onCurrentChanged: onCurrentChanged
    }
    
    const personString = props.plural ? i18n.spaceplanner.multipleAssignments.people : i18n.spaceplanner.multipleAssignments.person
    const title = i18n.spaceplanner.multipleAssignments.modalTitle
      .replace("{person}", personString)
      .replace("{to}", props.to)
    content = <AssignmentsPromptPeople {...selectProps} />
    let modalOptions = {
      title: title,
      className: "i-assign-people-modal",
      content: content,
      okLabel: i18n.spaceplanner.buttonLabel.assign
    }
    ModalController.confirm(modalOptions).then(result => {
      if (result.ok) {
        onOK()
      }
    })
  }
}